
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    N_A: "N_A",
    TSC: "TSC",
    KEY: "KEY",
    MUT: "MUT",
    NAT: "NAT",
    TBD: "TBD",
    PRI: "PRI",
    SEC: "SEC"
};
